import { callExternalApi, CallResult } from '../../callExternalApi';
import { PermissionSetAssignment } from '../../../types';

const BASE_URL = 'api/admin/permission_set_assignments';

// Exactly one scope must be set: user-level (portal_user_id + account_id) OR team-level (team_id).
export interface CreatePermissionSetAssignmentRequest {
  permission_set_id: string;
  portal_user_id?: number;
  account_id?: string;
  team_id?: number;
}

export const fetchPermissionSetAssignmentsApi = async (
  permissionSetId?: string
): Promise<CallResult<PermissionSetAssignment[]>> => {
  const query = permissionSetId ? `?permission_set_id=${encodeURIComponent(permissionSetId)}` : '';
  return await callExternalApi<PermissionSetAssignment[]>({ url: `${BASE_URL}${query}`, method: 'GET' });
};

const isUserScope = (body: CreatePermissionSetAssignmentRequest): boolean =>
  body.portal_user_id != null && body.account_id != null && body.team_id == null;

const isTeamScope = (body: CreatePermissionSetAssignmentRequest): boolean =>
  body.team_id != null && body.portal_user_id == null && body.account_id == null;

export const createPermissionSetAssignmentApi = async (
  body: CreatePermissionSetAssignmentRequest
): Promise<CallResult<PermissionSetAssignment>> => {
  if (!isUserScope(body) && !isTeamScope(body)) {
    return {
      data: null,
      error: {
        message: 'Assignment must be user-level (portal_user_id + account_id) or team-level (team_id), not both.'
      }
    };
  }
  return await callExternalApi<PermissionSetAssignment>({
    url: BASE_URL,
    method: 'POST',
    data: { permission_set_assignment: body }
  });
};

export const deletePermissionSetAssignmentApi = async (id: string): Promise<CallResult<void>> =>
  await callExternalApi<void>({ url: `${BASE_URL}/${id}`, method: 'DELETE' });
